module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!./rollover-request-investment-profile.ts"));
	}, "forms/member-investment-profile/rollover-request-investment-profile");
}